import React, { useState, useRef, useEffect } from 'react';

const COLOR_STYLES = {
  green: 'border-emerald-600/50 bg-emerald-950/40 text-emerald-200',
  blue: 'border-blue-600/50 bg-blue-950/40 text-blue-200',
  grey: 'border-slate-600 bg-slate-800/60 text-slate-300',
};

export default function ProvenanceBadge({ provenance }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onDoc = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, [open]);

  if (!provenance?.label) return null;

  const style = COLOR_STYLES[provenance.color] || COLOR_STYLES.grey;

  return (
    <div className="relative inline-block" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className={`rounded-full border px-3 py-1 text-xs font-semibold ${style}`}
        aria-expanded={open}
      >
        {provenance.label}
      </button>
      {open && (
        <div
          role="tooltip"
          className="absolute left-0 top-full z-20 mt-2 max-w-xs rounded-xl border border-slate-600 bg-slate-900 p-3 text-xs leading-relaxed text-slate-200 shadow-xl"
        >
          {provenance.tooltip}
        </div>
      )}
    </div>
  );
}
